import { Injectable } from '@angular/core';

@Injectable()
export class DoIQualifyCarrier {
    public carrier_id: number = null;
}